/*
    This program is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import { Component, inject, OnInit } from '@angular/core';
import { resolveApiPortBadge } from './shared/utils/api-port-badge';
import { NavegadorService } from './services/navegador.service';
import { OrigenConfigService } from './services/origen-config.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'gep-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'GEP - Gestor Escolar Diario do Professor';
  /** Só no deploy diarioteste: mostra a porta real da API atrás do /api. */
  protected readonly apiUpstreamPort = resolveApiPortBadge(
    typeof window === 'undefined' ? '' : window.location.hostname,
    environment.apiUpstreamPort,
  );
  private readonly navegadorService = inject(NavegadorService);
  private readonly origenConfigService = inject(OrigenConfigService);

  ngOnInit(): void {
    this.navegadorService.redirecionarParaChromeSeNecessario();
  }
}
